export const INQUIRY = '/inquiry/:id(\\d+)?'

export const INQUIRIES_GROUP = `${INQUIRY}/inquiries_group`
export const MY_INQUIRIES = `${INQUIRY}/list`
export const ADMIN_INQUIRIES = `${INQUIRY}/admin`
export const ASSIGNED_INQUIRIES = `${INQUIRY}/assigned`
